import { useTrackingEventsDatas } from "@/hooks";
import { useTrackingEvent } from "./useTrackingEvent";
import { useTracking } from "@/contexts/classified";
export const useTrackingCallbackAnswered = (av_zone) => {
    var _a, _b;
    const { av_client_type, av_items } = (_a = useTracking()) !== null && _a !== void 0 ? _a : {};
    const av_client_id = (_b = av_items === null || av_items === void 0 ? void 0 : av_items[0]) === null || _b === void 0 ? void 0 : _b.client_id;
    const EVENT_DATA = Object.assign(Object.assign({ event: "request_callback_contact_success", av_zone }, useTrackingEventsDatas({
        displayMedium: true,
        conversionType: "phone",
    })), { av_client_type,
        av_client_id });
    // request_callback_contact_success does not exist as a type in the ThorEventGA4Interface
    // so we cast to unknown on purpose
    // TODO: Check with team responsible for @aviv-dxp/react-thor should we add that into the typing
    return useTrackingEvent(EVENT_DATA);
};
